import React, { useState, useEffect } from 'react'
import { uangPangkalService } from '../services/uangPangkalService'

function UangPangkal() {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [selectedNba, setSelectedNba] = useState(null)
  const [selectedNama, setSelectedNama] = useState('')
  const [jumlah, setJumlah] = useState(300000)
  const [maxJumlah, setMaxJumlah] = useState(1200000)
  const [submitting, setSubmitting] = useState(false)
  const [message, setMessage] = useState(null)

  useEffect(() => { fetchData() }, [])

  const fetchData = async () => {
    try {
      const res = await uangPangkalService.getAll()
      setData(res.data.data || [])
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  const openBayar = (item) => {
    setSelectedNba(item.NBA)
    setSelectedNama(item.Nama)
    setMaxJumlah(item.Sisa)
    setJumlah(Math.min(300000, item.Sisa))
    setShowModal(true)
  }

  const submitBayar = async () => {
    if (jumlah <= 0 || jumlah > maxJumlah) {
      alert('Jumlah tidak valid')
      return
    }
    setSubmitting(true)
    try {
      const res = await uangPangkalService.bayar(selectedNba, { jumlah })
      setMessage({ type: 'success', text: res.data.message })
      setShowModal(false)
      fetchData()
    } catch (e) {
      setMessage({ type: 'danger', text: e.response?.data?.message || 'Gagal bayar' })
    } finally {
      setSubmitting(false)
    }
  }

  const formatRupiah = (val) => {
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(val || 0)
  }

  if (loading) {
    return <div className="text-center py-5"><div className="spinner-border text-primary"><span className="sr-only">Loading...</span></div></div>
  }

  return (
    <div className="container-fluid">
      <div className="row mb-3">
        <div className="col-12">
          <h4 className="text-white">Uang Pangkal Anggota</h4>
        </div>
      </div>

      {message && (
        <div className={`alert alert-${message.type} alert-dismissible fade show`}>
          {message.text}
          <button type="button" className="close" onClick={() => setMessage(null)}>&times;</button>
        </div>
      )}

      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead className="thead-light">
                <tr>
                  <th>No</th>
                  <th>Nama</th>
                  <th>NBA</th>
                  <th>Total</th>
                  <th>Dibayar</th>
                  <th>Sisa</th>
                  <th>Cicilan</th>
                  <th>Status</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, i) => (
                  <tr key={item.NBA}>
                    <td>{i + 1}</td>
                    <td>{item.Nama}</td>
                    <td>{item.NBA}</td>
                    <td>{formatRupiah(item.Total)}</td>
                    <td>{formatRupiah(item.Dibayar)}</td>
                    <td className="text-danger font-weight-bold">{formatRupiah(item.Sisa)}</td>
                    <td>{item.CicilanKe}/{item.JumlahCicilan}</td>
                    <td>
                      <span className={`badge ${item.Status === 'Lunas' ? 'badge-success' : 'badge-warning'}`}>
                        {item.Status}
                      </span>
                    </td>
                    <td>
                      {item.Status === 'Belum Lunas' && (
                        <button className="btn btn-sm btn-primary" onClick={() => openBayar(item)}>
                          <i className="fas fa-credit-card mr-1"></i> Bayar
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
                {data.length === 0 && (
                  <tr><td colSpan="9" className="text-center text-muted py-4">Tidak ada data uang pangkal</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Bayar Uang Pangkal</h5>
                <button type="button" className="close" onClick={() => setShowModal(false)}>&times;</button>
              </div>
              <div className="modal-body">
                <p><strong>Anggota:</strong> {selectedNama} ({selectedNba})</p>
                <p><strong>Sisa:</strong> {formatRupiah(maxJumlah)}</p>
                <div className="form-group">
                  <label>Jumlah Pembayaran</label>
                  <input type="number" className="form-control" value={jumlah}
                    onChange={e => setJumlah(Number(e.target.value))}
                    min="1" max={maxJumlah} />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Batal</button>
                <button className="btn btn-primary" onClick={submitBayar} disabled={submitting}>
                  {submitting ? 'Memproses...' : 'Bayar'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default UangPangkal
